import Icon from "@/components/Icon"
import { hasValue } from "@/helpers/typeguards"

function CountPill({
  isLoading,
  value,
}: {
  isLoading: boolean
  value?: number
}) {
  return (
    <div
      className="
        flex min-w-11 items-center justify-center rounded-sm bg-primary-200 px-2
        py-1 text-neutral-100
      "
    >
      {hasValue(value) ? (
        <span>{value.toString()}</span>
      ) : isLoading ? (
        <Icon name="spinner" size="sm" />
      ) : (
        <Icon name="ban" size="sm" />
      )}
    </div>
  )
}

export default CountPill
